import moment from 'moment'

export const GRAPHQL_URL = 
    (typeof(window) !== 'undefined' && (
     window.location.href.indexOf('-test') > 0 || 
     window.location.href.indexOf('-dev') > 0)) ?
        'https://graphql-test.canadiandiscovery.com/' :
        'https://graphql.canadiandiscovery.com/'

export const graphqlFetch = (schema, query, variables = {}) => {
    const url = schema ? 
        `${GRAPHQL_URL}${schema}/graphql` :
        `${GRAPHQL_URL}graphql`
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Accept-Encoding': 'gzip, deflate, br',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
            query,
            variables
        })
    }).then(res => res.json())
}

export const sortFn = (x, y) => x > y ? 1 : x < y ? -1 : 0
export const sortDescFn = (x, y) => x > y ? -1 : x < y ? 1 : 0
export const sortPropFn = property => (x, y) => 
  x[property] > y[property] ? 1 :
  x[property] < y[property] ? -1 :
  0
export const sortPropDescFn = property => (x, y) =>
  x[property] > y[property] ? -1 :
  x[property] < y[property] ? 1 :
  0

export const numberSortFn = (x, y) => x - y
export const numberSortDescFn = (x, y) => y - x

/** Checks if an object is empty or not */
export const objectEmpty = obj => Object.keys(obj).length === 0

/** Checks if an object or all it's properties are empty or not */
export const objectDeepEmpty = obj => {
    let empty = true
    if (!objectEmpty(obj)) {
        for (const property in obj) {
            const hasValue = 
                typeof(obj[property]) == 'object' &&
                obj[property] !== null ?
                    !objectDeepEmpty(obj[property]) :
                    typeof(obj[property]) !== 'undefined'
            if (hasValue) {
                empty = false
                break;
            }
        }
    }
    return empty
}

/** Immutably updates the properties of one object with another */
export const updateObject = (initial, updates) => { return { ...initial, ...updates } }

/** Recursively checks for object equality. Pulled from: https://gist.github.com/nicbell/6081098 */
export const objectEquals = function (initial, secondary) {
    if (!initial && !secondary) return true
    else if (!initial || !secondary) return false

    for (const property in initial) {
        //Check property exists on both objects
        if (initial.hasOwnProperty(property) !== secondary.hasOwnProperty(property)) return false

        switch (typeof (initial[property])) {
            //Deep compare objects
            case 'object':
                if (!objectEquals(initial[property], secondary[property])) return false
                break
            //Compare function code
            case 'function':
                if (typeof (secondary[property]) == 'undefined' || (property !== 'compare' && initial[property].toString() !== secondary[property].toString())) return false
                break
            //Compare values
            case 'undefined':
                if (typeof (secondary[property]) !== 'undefined') return false
                break;
            default:
                if (initial[property] !== secondary[property]) return false
        }
    }

    //Check object 2 for any extra properties
    for (const property in secondary) {
        if (!initial.hasOwnProperty(property)) return false
    }
    return true
}

/** Clears an Object */
export const clearObject = (obj, val = undefined) => {
    let clearedObj = {}
    for (const property in obj) {
        clearedObj[property] = 
            typeof(obj[property]) == 'object' ?
                clearObject(obj[property], val) :
                val
    }

    return clearedObj
}

/** Truncates a string to the passed length */
export const truncate = (str, length) => str ? (str.length < length ? str : str.substring(0, length).trim() + '...') : (str)

/** Tries to get a cookie with the given name */
export const getCookie = (cookieName) => {
    const cookie =
        document.cookie
            .split(';')
            .filter(c => c.trim().startsWith(cookieName))
    
    return cookie[0] ?
    cookie[0].split('=')[1] :
    undefined
}
export const setCookie = (name, value, days = 30) => {
    let date = new Date()
    date = new Date(date.setDate(date.getDate() + days))
    document.cookie = `${name}=${value};expires=${date.toUTCString()};domain=.canadiandiscovery.com`
}

/** Check for user login */
export const authenticated = async (role = "CDD") => {
    const response = await graphqlFetch('auth', `
        query {
            hasRole(roleName: "${role}")
        }`)

    return !!(response.data && response.data.hasRole)
}

/** Pulls any url params as an object */
export const parseUrlParams = () => {
    if (!window.location.search)
        return {}
    
    const params = 
        window.location.search
        .substring(1) // remove the beginning '?'
        .split('&')
    
    return params.reduce((acc, param) => {
        if (param.indexOf('=')) {
            const keyVal = param.split('=')
            acc[keyVal[0]] = keyVal[1]
        }
        return acc
    } , {})
}

// Taken from https://stackoverflow.com/questions/442404/retrieve-the-position-x-y-of-an-html-element#answer-28222246
export const getOffset = el => {
    const rect = el.getBoundingClientRect()
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY,
      height: el.offsetHeight,
      width: el.offsetWidth
    }
}

export const scrollTo = (selector) => {
    const element = document.querySelector(selector);

    if (element) {
        const topPos = element.offsetTop;
        const height = document.getElementsByClassName('mdc-top-app-bar__row')[0].offsetHeight;
        document.getElementsByClassName('layout__content__page_content')[0].scrollTop = topPos - height - 30;
    }
}

// Taken from https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
export const copyToClipboard = str => {
    const el = document.createElement('textarea')
    el.value = str
    el.setAttribute('readonly', '')
    el.style.position = 'absolute'
    el.style.left = '-9999px'
    document.body.appendChild(el)
    const selected =
        document.getSelection().rangeCount > 0
            ? document.getSelection().getRangeAt(0)
            : false
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
    if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
    }
};

export const contains = (collection, token) => collection.indexOf(token) > -1

// Taken from https://www.jstips.co/en/javascript/create-range-0...n-easily-using-one-line/
export const createLengthArray = size => Array.from(new Array(size),(_,index) => index + 1)

export const replaceAll = (str, replacements) =>
    Object.keys(replacements).reduce(
        (acc, key) => {
            while(contains(acc, key))
                acc = acc.replace(key, replacements[key])

            return(acc)
        }, str)

export const $ = selector => document.querySelector(selector)

export const onPhone = () => document.body.clientWidth < 480
export const onTablet = () => document.body.clientWidth > 480 && document.body.clientWidth < 768
export const onDesktop = () => document.body.clientWidth > 768

export const isEdge = () => window.navigator.userAgent.indexOf('Edge') > -1
export const isIE = () => 
    window.navigator.userAgent.indexOf('MSIE ') > -1 ||
    window.navigator.userAgent.indexOf('Trident/') > -1

export const mergeSearch = (currentSearch, newSearch, removeList = []) => {
    const parseParamString = (params) => {
        return params ?
            regexSplit(params.replace('?', ''), /&[^&=]+=/)
                .reduce((acc, param) => {
                    const split = param.split('=')
                    return contains(removeList, split[0]) ?
                        acc : { ...acc, [split[0]]: split[1] }
                }, {}) :
            {}
    }
    
    const search = { ...parseParamString(currentSearch), ...parseParamString(newSearch) }
    return '?' + 
        Object.keys(search)
            .map(key => search[key] ? `${key}=${search[key].toString()}` : undefined)
            .filter(x => x) // filter out undefineds
            .join('&')
}

// Splits a string using a regexp. Split occurs at the start index of the pattern.
export const regexSplit = (str, pattern) => {
    const tokens = []

    let i = str.search(pattern)
    while(i > -1) {
        tokens.push(str.substring(0, i))
        str = str.substring(i + 1)
        
        i = str.search(pattern)
    }
    tokens.push(str)

    return tokens
}

export const formatDate = (date, options = { month: 'long', day: 'numeric', year: 'numeric' }) => 
    moment(date).toDate().toLocaleDateString('en-US', options)

export const guid = () => {
    const rand = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)    
    return rand() + "-" + rand() + "-" + rand() + "-" + rand() + "-" + rand()
}